module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "p-fluid p-formgrid p-grid "
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-9"
  }), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-1"
  }, [_c('Button', {
    staticClass: "p-button-raised btn",
    attrs: {
      "label": "Print",
      "icon": "pi pi-print"
    },
    on: {
      "click": _vm.generateReport
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-1"
  }, [_c('Button', {
    staticClass: "p-button-raised p-button-danger btn",
    attrs: {
      "label": "Cancel"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.back()
      }
    }
  })], 1)]), _vm._v(" "), _c('Card', {
    scopedSlots: _vm._u([{
      key: "content",
      fn: function() {
        return [_c('div', {
          staticClass: "p-fluid p-formgrid p-grid"
        }, [_c('div', {
          staticClass: "p-field p-col-12 p-md-4"
        }), _vm._v(" "), _c('div', {
          staticClass: "p-field p-col-12 p-md-4"
        }, [_c('img', {
          staticClass: "center",
          attrs: {
            "src": _vm.$store.state.organisationLogo
          }
        })]), _vm._v(" "), _c('div', {
          staticClass: "p-field p-col-12 p-md-4"
        })]), _vm._v(" "), _c('div', {
          staticClass: "p-fluid p-formgrid p-grid "
        }, [_c('div', {
          staticClass: "p-field p-col-12 p-md-12"
        }, [_c('label', [_vm._v("Date: " + _vm._s(_vm.nepaliDate))])]), _vm._v(" "), _c('div', {
          staticClass: "p-field p-col-12 p-md-12"
        }, [_c('label', [_vm._v("Bill No: " + _vm._s(_vm.billNo))])]), _vm._v(" "), _c('div', {
          staticClass: "p-field p-col-12 p-md-12"
        }, [_c('label', [_vm._v("Customer : " + _vm._s(_vm.customerName))])]), _vm._v(" "), _c('div', {
          staticClass: "p-field p-col-12 p-md-12"
        }, [_c('label', [_vm._v("Contact No: " + _vm._s(_vm.customerNumber))])]), _vm._v(" "), _c('div', {
          staticClass: "p-field p-col-12 p-md-12"
        }, [_c('label', [_vm._v("Address: " + _vm._s(_vm.address))])]), _vm._v(" "), _c('div', {
          staticClass: "p-field p-col-12 p-md-12"
        }, [_c('label', [_vm._v("Product Name: " + _vm._s(_vm.productName))])]), _vm._v(" "), _c('div', {
          staticClass: "p-field p-col-12 p-md-12"
        }, [_c('label', [_vm._v("Quantity: " + _vm._s(_vm.quantity))])]), _vm._v(" "), _c('div', {
          staticClass: "p-field p-col-12 p-md-12"
        }, [_c('label', [_vm._v("Bill Amount: " + _vm._s(_vm.billAmount + _vm.deliveryCharge))])]), _vm._v(" "), _c('div', {
          staticClass: "p-field p-col-12 p-md-12"
        }, [_c('label', [_vm._v("Remarks: " + _vm._s(_vm.remarks))])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
          staticClass: "p-fluid p-formgrid p-grid "
        }, [(_vm.organisationName == 'Martin Wears') ? _c('div', {
          staticClass: "p-field p-col-12 p-md-12",
          staticStyle: {
            "text-align": "center"
          }
        }, [_c('b', [_vm._v("Thank you for shopping with us.")]), _c('br'), _vm._v(" "), _c('b', [_vm._v("Your satisfaction is our priority.")]), _c('br'), _vm._v(" "), _c('b', [_vm._v("If you like our products please mention us on your.")]), _c('br'), _vm._v(" "), _c('b', [_vm._v("Instagram story will mean alot.")])]) : _c('div', {
          staticClass: "p-field p-col-12 p-md-12",
          staticStyle: {
            "text-align": "center"
          }
        }, [_vm._v("\n           " + _vm._s(_vm.orgRemarks === '' ? 'Thank you for shopping with us.' : _vm.orgRemarks) + "\n         ")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
          staticClass: "p-fluid p-formgrid p-grid "
        }, [_c('div', {
          staticClass: "p-field p-col-12 p-md-12"
        }, [_c('span', [_c('b', [_vm._v(_vm._s(_vm.organisationName === '' ? 'N/A' : _vm.organisationName))])])]), _vm._v(" "), _c('div', {
          staticClass: "p-field p-col-12 p-md-12"
        }, [_c('span', [_vm._v(_vm._s(_vm.organisationAddress === '' ? 'N/A' : _vm.organisationAddress))])]), _vm._v(" "), _c('div', {
          staticClass: "p-field p-col-12 p-md-12"
        }, [_c('span', [_vm._v(_vm._s(_vm.organisationContact === '' ? 'N/A' : _vm.organisationContact))])]), _vm._v(" "), _c('div', {
          staticClass: "p-grid p-col-12"
        }, [_c('span', {
          staticStyle: {
            "font-size": "10px"
          }
        }, [_vm._v("Powered By Raise Tech Pvt.Ltd.")])])])]
      },
      proxy: true
    }])
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0a67860d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/pos/deliveryPrintPage.vue
// module id = 2027
// module chunks = 0